// DEV-only preview bypass — `npm run dev:preview` sets VITE_AUTH_BYPASS=true so
// the whole app (including admin-gated routes) is browsable without a login for
// the design/stub phase. `import.meta.env.DEV` guarantees it can NEVER apply to a
// production build (DEV is false there). Single source shared by the route gates.
export const AUTH_BYPASS = import.meta.env.DEV && import.meta.env.VITE_AUTH_BYPASS === 'true'
